import React from "react"
import Tooltip from "./tooltip"
import store from "src/store"
import CopyToClipboardComponent from "src/utils/copy-to-clipboard";

export default function Byte32Display({ byte32 = "" }) {
  const getByte32Name = () => {
      let byte32variableName = store.selectedSimulationData.byte32List ? store.selectedSimulationData.byte32List[byte32] : '';
      let byte32shorten =
        `${byte32.substring(0, 7)}...` + `${byte32.substring(byte32.length - 7)}`;
        
      if (byte32variableName) {
        return byte32variableName + "(" +byte32shorten+")"
      } else {
          return byte32shorten;
      }
  }
  return (
    <>
      <Tooltip tip={byte32}>
        {getByte32Name()}
      </Tooltip>
      {byte32 && <CopyToClipboardComponent text={byte32} />}
    </>
  )
}
